//import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
//import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import { Provider as AlertProvider } from 'react-alert';
import App from './App';
import { AlertTemplate, options } from './components/widgets/AlertTemplate';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from './components/security/ADAuthConfig';


// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(/*history,*/ initialState);

const pca = new PublicClientApplication(msalConfig);

const rootElement = document.getElementById('root');

window.globalAppRXStore = store;
window.globalAppADStore = pca;

ReactDOM.render(
    <Provider store={store}>
        {/*<ConnectedRouter history={history} basename={process.env.PUBLIC_URL}>*/}
        <AlertProvider template={AlertTemplate} {...options}>
            <MsalProvider instance={pca}>
                <App />
            </ MsalProvider>
        </AlertProvider>
        {/*</ConnectedRouter>*/}
    </Provider>,
    rootElement);

//registerServiceWorker();
unregister();